import React from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ProgressBar } from "react-loader-spinner";

const GameView = styled.div`
  height: 600px;
  width: 100%;
  border-radius: 15px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  .info-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 30px;
    .info {
      border-radius: 50%;
      height: 50px;
      width: 50px;
      border: 4px solid black;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
    }
  }
  @media screen and (max-width: 768px) {
    height: 500px;
  }
  @media screen and (max-width: 577px) {
    height: 250px;
  }
`;
function Games({ params, isMobile, token }) {
  const { unityProvider,loadingProgression, isLoaded,} = useUnityContext({
    loaderUrl: `/${params}/${params}.loader.js`,
    dataUrl: `/${params}/${params}.data`,
    frameworkUrl: `/${params}/${params}.framework.js`,
    codeUrl: `/${params}/${params}.wasm`,
  });
  const { t } = useTranslation();
  const loadingPercentage = Math.round(loadingProgression * 100);

  return (
    <GameView>
      {process.env.REACT_APP_BETA_TESTING === "true" && !token ? (
        <div className="info-container">
          <p className="info">!</p>
          <p style={{ textAlign: "center" }}>{t("wallet_connect_error")}</p>
        </div>
      ) : !isMobile ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "15px",
            backgroundColor: "white",
            position: "relative",
          }}
        >
          {isLoaded === false && (
            <div
              style={{
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
                borderRadius: "15px",
              }}
            >
              {/* <p style={{fontSize: "20px"}}>{t("game_loading_message")}</p> */}
              <div
              style={{
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
                borderRadius: "15px",
              }}
            >
              <ProgressBar
                height="170"
                width="170"
                ariaLabel="progress-bar-loading"
                wrapperStyle={{}}
                wrapperClass="progress-bar-wrapper"
                borderColor = '#8ad0ea'
                barColor = '#fed742'
              />
              <p style={{fontSize: "20px",position:'absolute'}}>({loadingPercentage}%)</p>
            </div>
            </div>
          )}
          <Unity
            unityProvider={unityProvider}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "15px",
            }}
          />
        </div>
      ) : (
        <div className="info-container">
          <p className="info">!</p>
          <p style={{ textAlign: "center" }}>{t("mobile_validation_title")}</p>
        </div>
      )}
    </GameView>
  );
}

export default Games;
